import React from 'react';
import { Monitor } from 'lucide-react';

/**
 * Reusable component to display when desktop/landscape mode is required
 * @param {string} feature - The feature name that requires desktop (e.g., "canvas editor", "templates")
 */
const DesktopRequiredScreen = ({ feature = "this feature" }) => {
  return (
    <div className="flex items-center justify-center h-screen bg-ag-black-800 p-6">
      <div className="text-center max-w-md">
        <Monitor className="w-20 h-20 text-ag-green mx-auto mb-6" />
        <h1 className="text-2xl font-bold text-white mb-4">
          Desktop Required
        </h1>
        <p className="text-gray-300 mb-2">
          {feature.charAt(0).toUpperCase() + feature.slice(1)} requires a desktop or laptop computer with a landscape display.
        </p>
        <p className="text-gray-400 text-sm">
          Please switch to a larger device or rotate your tablet to landscape mode to continue.
        </p>
      </div>
    </div>
  );
};

export default DesktopRequiredScreen;
